import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { LanguageSelect } from '../inputs';
import { useAuth } from '../../store/auth';
import { ReactComponent as LogoutIcon } from '../../assets/svg/logout.svg';

interface OnboardingHeaderProps {
  hideLanguageSelect?: boolean;
  logoCustom?: string;
  showLogoutButton?: boolean;
}

const OnboardingHeader: React.FC<OnboardingHeaderProps> = (props) => {
  const { hideLanguageSelect, logoCustom, showLogoutButton = false } = props;
  const isLogoDefault = logoCustom || '/img/new-logo.png';

  const { logout, token } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const shouldShowLogout = useMemo(() => showLogoutButton && Boolean(token), [showLogoutButton, token]);

  const handleLogout = useCallback(() => {
    logout();
    navigate('/login');
  }, [logout, navigate]);

  const showRightContent = !hideLanguageSelect || shouldShowLogout;

  return (
    <div className="flex w-full items-center gap-3">
      <img src={isLogoDefault} className="max-h-[40px] max-w-[220px]" />
      {showRightContent ? (
        <div className="ml-auto flex items-center gap-3">
          {hideLanguageSelect ? undefined : <LanguageSelect />}
          {shouldShowLogout ? (
            <button
              type="button"
              onClick={handleLogout}
              aria-label={t('buttons.btnLogOut') || 'Logout'}
              className="flex h-8 w-8 items-center justify-center rounded border border-[#23155B] text-[#23155B] transition-colors duration-150 hover:bg-[#23155B] hover:text-white"
            >
              <LogoutIcon className="h-4 w-4 fill-current" />
            </button>
          ) : undefined}
        </div>
      ) : undefined}
    </div>
  );
};

export { OnboardingHeader };
